import React from 'react';
import { Autoplay, EffectFade } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-fade';

import Container from '@/components/@base/container';
import BestSellerBadge from '@/components/app/product/components/best-seller-badge';
import DigiPayBadge from '@/components/app/product/components/digipay-badge';
import SnappPayBadge from '@/components/app/product/components/snappPay-badge';

import ProductModel from '@/models/product.model';

type Props = {
  productData: ProductModel;
};

export default function Badges({ productData }: Props) {
  const badges: React.ReactNode[] = [];

  if (
    productData.snappPayBadge &&
    productData.snappPayBadge?.title &&
    productData.snappPayBadge?.description
  ) {
    badges.push(<SnappPayBadge {...productData.snappPayBadge} key='snappPay' />);
  } else {
    if (productData.bestSellerBadge)
      badges.push(<BestSellerBadge {...productData.bestSellerBadge} key='bestSeller' />);

    if (productData.digiPayBadge)
      badges.push(<DigiPayBadge {...productData.digiPayBadge} key='digiPay' />);
  }

  if (badges.length === 0) return null;

  if (badges.length === 1) {
    return <Container>{badges[0]}</Container>;
  }

  return (
    <Container>
      <Swiper
        modules={[EffectFade, Autoplay]}
        effect='fade'
        speed={1500}
        fadeEffect={{ crossFade: true }}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        loop
        preventClicks
        preventClicksPropagation
        className='badges-swiper'
      >
        {badges.map((badge, i) => (
          <SwiperSlide key={i}>
            <div style={{ pointerEvents: 'none' }}>{badge}</div>
          </SwiperSlide>
        ))}
      </Swiper>
    </Container>
  );
}
